export default "__VITE_ASSET__wvpnVzp4__"